import PropTypes from 'prop-types';
import s from './Log.module.css';
import { ApprovedSucces } from 'components/iconComponent/ApprovedSucces';
import { ApprovedError } from 'components/iconComponent/ApprovedError';

const Log = ({ time, id, vote, icon }) => {
  return (
    <div className={s.log} key={id}>
      <div className={s.time}>{time}</div>
      <div className={s.text}>
        <div>
          Image ID: <span className={s.id}>{id}</span> was added to {vote}
        </div>
        <div className={s.icon}>{icon}</div>
      </div>
    </div>
  );
};

const LogRemove = ({ time, id }) => {
  return (
    <div className={s.log} key={id}>
      <div className={s.time}>{time}</div>
      <div className={s.text}>
        <div>
          Image ID: <span className={s.id}>{id}</span> was removed from
          Favorites
        </div>
      </div>
    </div>
  );
};

const LogApproved = () => {
  return (
    <div className={s.log__approved}>
      <div>
        <ApprovedSucces />
      </div>
      <div className={s.text}>Thanks for the Upload - Cat found!</div>
    </div>
  );
};

const LogNotApproved = () => {
  return (
    <div className={s.log__approved}>
      <div>
        <ApprovedError />
      </div>
      <div className={s.text}>No Cat found - try a different one</div>
    </div>
  );
};

export { Log, LogRemove, LogApproved, LogNotApproved };

Log.propTypes = {
  time: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  vote: PropTypes.string.isRequired,
  icon: PropTypes.element,
};

LogRemove.propTypes = {
  time: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};
